var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-bubble',{attrs:{"isMine":_vm.isMine,"message":_vm.message}},[_c('a',{staticClass:"geo-element",attrs:{"href":_vm.href,"target":"_blank","title":"点击查看详情"}},[_c('span',{staticClass:"el-icon-location-outline"},[_vm._v(_vm._s(_vm.payload.description))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.url}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-213b8a94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/message/message-elements/geo-element.vue
// module id = null
// module chunks = 